export const constant = {
  FORMAT: "YYYY-MM-DD HH:mm:ss",
  PAGENUMBER: 1,
  MIN_lENGTH: 6,
  IMG_EXTENTION: "image/",
  IMG_WEBP_EXTENTION: "image/webp",
  PASSWORD: "password",
  CONFIRM_PASSWORD: "connfirm_password",
  OLDPASSWORD: "old_password",
  BSDATEFORMATE: "yyyy-MM-dd HH:mm:ss",

  AUTHROUTE: {
    login: "user-service/v1/sign-in",
    verifyTwoFactorOtp: "user-service/v1/sign-in-2fa-verify",
    resendTwoFactorOtp: "user-service/v1/sign-in-2fa-resend",
    forgotPassword: "user-service/v1/forgot-password",
    forgotPasswordTokenVerify: "user-service/v1/forgot-password-token-verify",
    reserPassword: "user-service/v1/reset-password",
    CHANGE_PASSWORD: "user-service/v1/change-password",
    signUp: "user-service/v1/sign-up",
    metaData: "user-service/v1/meta-data/get-details",
  },
  APIROUTES: {
    UPLOAD_DOC: "user-service/v1/upload-document",
    BUSINESS_LIST: "user-service/v1/business-list",
    REISSUE_BUSINESS_VIRTUAL_ACCOUNT: "user-service/v1/reissue_business_virtual_account",
    TRANSACTION_LIST: "transaction-service/v1/list",
    TRANSACTION_DETAILS: "transaction-service/v1/details",
    TRANSACTION_DETAIL: "transaction-service/v1/listStatistics",
    REFUND_TRANSACTION: "transaction-service/v1/refund-transaction",
    REFUND_DETAILS: "transaction-service/v1/refund-details",
    REFUND_LIST: "transaction-service/v1/refund-list",
    REFUND_BY_REFRENCE: "transaction-service/v1/refund-by-reference",
    PROFILE_DETAILS: "user-service/v1/settings/get-profile",
    UPDATE_SETTING_PROFILE_DATA: "user-service/v1/settings/update-profile",
    GET_MEMBER_LIST: "user-service/v1/settings/get-team-members",
    ENFORCE_2FA: "user-service/v1/settings/enforce-2fa",
    GET_ROLE_LIST: "user-service/v1/settings/get-roles",
    GET_ROLE_DETAIL: "user-service/v1/settings/get-role-detail",
    CREATE_ROLE: "user-service/v1/settings/add-custom-role",
    UPDATE_ROLE: "user-service/v1/settings/update-role",
    INVITE_MEMBER: "user-service/v1/settings/invite-team-member",
    REMOVE_INVITE_MEMBER: "user-service/v1/settings/remove-team-member",
    GET_COMPLIANCE: "user-service/v1/settings/get-compliance",
    TRANSFER_OTP: "user-service/v1/settings/send-tranfer-OTP",
    TRANSFER_VERIFY_OTP: "user-service/v1/settings/verify-tranfer-OTP",
    TRANSFER_CONSUME_OTP: "user-service/v1/settings/consume-transfer-OTP",
    UPDATE_COMPLIANCE_PROFILE_DETAILS:
      "user-service/v1/settings/update-compliance-profile-detail",
    UPDATE_COMPLIANCE_CONTACT_DETAILS:
      "user-service/v1/settings/update-compliance-contact-detail",
    OWNER_PHONE_STATUS: "user-service/v1/settings/owner-phone-status",
    OWNER_PHONE_VERIFY: "user-service/v1/settings/owner-phone-verify",
    UPDATE_COMPLIANCE_ACCOUNT_DETAILS:
      "user-service/v1/settings/update-compliance-account-detail",
    GET_BUSINESS_DIRECTOR_DETAILS:
      "user-service/v1/settings/get-business-director-detail",
    UPDATE_COMPLIANCE_REGISTRATION_DETAIL:
      "user-service/v1/settings/update-compliance-registration-detail",
    DELETE_BUSINESS_DIRECTOR_DETAILS:
      "user-service/v1/settings/delete-business-director-detail",
    ADD_BUSINESS_DIRECTOR: "user-service/v1/settings/add-business-director",
    GET_AUDIT_LOGS: "user-service/v1/settings/audit-logs",
    UPDATE_BUSINESS_DIRECTOR:
      "user-service/v1/settings/update-business-director-detail",
    GET_PREFERENCES: "user-service/v1/settings/get-preferences",
    GET_TRANSFER_OTP_PREFERENCE: "user-service/v1/settings/get-transfer-otp-preference",
    UPDATE_PREFERENCES:
      "user-service/v1/settings/update-preferences-payments-detail",
    UPDATE_PREFERENCES_PAGINATION_DETAIL:
      "user-service/v1/settings/update-preferences-pagination-detail",
    UPDATE_PREFERENCES_SUBSCRIPTIONS_DETAIL:
      "user-service/v1/settings/update-preferences-subscriptions-detail",
    GET_BVN_URL: "transaction-service/v1/bvn/url",
    VERIFY_CODE: "transaction-service/v1/bvn/verify-code",
    ROLE_LIST: "setting/team/role",
    BANK_LIST: "transaction-service/v1/bank-list",
    TRANSACTION_WITH_BANK: "transaction-service/v1/transaction-with-bank",
    TRANSACTION_WITH_CARD: "transaction-service/v1/transaction-with-card",
    PAYMET_DETAILS: "payment-service/v1/payment-pages/get-page-detail-by-token",
    ADD_CUSTOMER: "customer-service/v1/customer-create",
    ADD_NEW_BUSINESS: "user-service/v1/add-new-business",
    TRANSFER_LIST: "transaction-service/v1/transfer/get-transfer-list",
    RECIPITANT_LIST: "transaction-service/v1/transfer/get-recipient-list",
    RECIPIENT_DETAILS: "transaction-service/v1/transfer/get-recipient-details",
    RECIPIENT_BLACK_LIST: "transaction-service/v1/transfer/blacklist-recipient",
    DELETE_RECIPIENT: "transaction-service/v1/transfer/recipient",
    VERIFY_BANK: "transaction-service/v1/bank-verify",
    CREATE_SINGLE_TRANSFER:
      "transaction-service/v1/transfer/create-single-transfer",
    CHECK_BALANCE: "transaction-service/v1/transfer/balance",
    TRANSFER_LIST_CSV: "transaction-service/v1/transfer/get-transfer-list-csv",
    TRANSACTION_WITH_USSD: "transaction-service/v1/transaction-with-ussd",
    TRANSACTION_WITH_QR: "transaction-service/v1/transaction-with-qr",
    NQR_ORDER: "transaction-service/v1/nqr/orderquery",
    CANCEL_NQR_ORDER: "transaction-service/v1/nqr/cancel",
    TRANSACTION_WITH_USSD_VERIFY: "transaction-service/v1/transaction-with-ussd-verify",
    VERIFY_ACCESSCODE: "transaction-service/v1/verify-accesscode",
    DASHBORD_GRAPH_DATA:
      "transaction-service/v1/dashboard/get-transaction-filter",
    CHANGE_BUSINESS: "user-service/v1/change-business",
    CHANGE_BUSINESS_MODE: "user-service/v1/change-business-mode",
    DASHBOARD_BALANCE_HISTORY:
      "transaction-service/v1/dashboard/balance-history",
    DASHBOARD_BALANCE_HISTORY_CSV:
      "transaction-service/v1/dashboard/balance-history-csv",
    DEBIT_ACCOUNTS: "transaction-service/v1/debit-accounts",
    BANK_LIST_PAYPLUS: "transaction-service/v1/bank-list-payplus",
    VERIFY_ACCOUNT: "transaction-service/v1/verify-account",
    SUBMIT_BULK_TRANSACTION:
      "transaction-service/v1/transfer/submit-bulk-transfer",
    TRANSFER_DETAIL: "transaction-service/v1/transfer/transfer-details",
    MAIL_TRANSFER_LIST: "transaction-service/v1/transfer/mail-transfer-list",
    REFRESH_API_KEY: "user-service/v1/refresh-api-key",
    FETCH_API_KEY: "user-service/v1/fetch-api-key",
    SAVE_WEBHOOK_CONFIG: "user-service/v1/save-webhook-config",
    FETCH_WEBHOOK_CONFIG: "user-service/v1/fetch-webhook-config",
    CREATE_DYNAMIC_VIRTUAL_ACCOUNT:
      "payment-service/v1/payment-pages/create-dynamic-virtual-account",
    INITIATE_DYNAMIC_VIRTUAL_ACCOUNT:
      "payment-service/v1/payment-pages/initiate-dynamic-virtual-account",
    INITIATE_INITIALIZE_CHECKOUT_DYNAMIC_VIRTUAL_ACCOUNT:
      "payment-service/external/v1/payment-pages/initiate-initialize-checkout-dynamic-virtual-account",
    CHECK_TRANSFER_STATUS: "payment-service/v1/payment-pages/transfer-status",
    BVN_VERIFY: "user-service/v1/bvnAuthLogin",
    TRANSFER_CHARGES: "transaction-service/v1/transfer/get-transfer-charges",
    REPEAT_TRANSFER: "transaction-service/v1/transfer/repeat-transfer",
    GET_BUSINESS_DETAILS: "user-service/v1/get-business-detail?businessId=",
    CHECK_BUSINESS_STATUS: "user-service/v1/check-business-activation-status",
    GET_TEAM_MEMBER_DATA_USING_TOKEN:
      "user-service/v1/settings/get-invite-team-member",
    JOIN_TEAM: "user-service/v1/settings/join-team-member",
    CHANGE_TEAM_MEMBER_ROLE: "user-service/v1/settings/team-member-role-change",
    ACTIVATE_BUSINESS: "user-service/v1/active_business",
    CHECK_TRANSACTION_VALID: "transaction-service/v1/check-transaction-valid",
  },
  CUSTOMER: {
    CUSTOMER_LIST: "customer-service/v1/list",
    CUSTOMER_DETAILS: "customer-service/v1/get-customer-by-id",
    ADD_CUSTOMER: "customer-service/v1/create",
    UPDATE_CUSTOMER: "customer-service/v1/customer-update",
    BLACK_LIST_CUSTOMER: "customer-service/v1/black-listed",
    CUSTOMRR_CSV: "customer-service/v1/csv-list",
    CREATE_VIRTUAL_ACCOUNT: "customer-service/v1/create-virual-account",
  },
  PAYMENTROUTE: {
    PAYMENT_PAGE_GET_PRODUCT:
      "payment-service/v1/payment-pages/payment-page-get-product",
    PAYMENT_PAGE_ADD_PRODUCT:
      "payment-service/v1/payment-pages/payment-page-add-product",
    PAYMENT_PAGE_DELETE_PRODUCT:
      "payment-service/v1/payment-pages/payment-page-delete-product",
    PAYMENT_PAGE_PRODUCT_PAY_NOW:
      "payment-service/v1/payment-pages/product-pay-now",
    PAYMENT_PAGE_LIST: "payment-service/v1/payment-pages/get-pages",
    PAYMENT_PAGE_DETAILS: "payment-service/v1/payment-pages/get-page-details",
    CREATE_PAYMENT_PAGE: "payment-service/v1/payment-pages/create-pages",
    UPDATE_PAYMENT_PAGE: "payment-service/v1/payment-pages/update-page-details",
    DELETE_PAYMENT_PAGE: "payment-service/v1/payment-pages/delete-page",
    INVOICE_LIST: "payment-service/v1/payment-pages/get-invoice",
    INVOICE_dETAIL: "payment-service/v1/payment-pages/get-invoice-details",
    CREATE_INVOICE: "payment-service/v1/payment-pages/create-invoice",
    CREATE_TEXT_INVOICE: "payment-service/v1/payment-pages/create-tax-invoice",
    SEND_TEXT_INVOICE: "payment-service/v1/payment-pages/send-tax-invoice",
    UPDATE_PAGE_STATUS: "payment-service/v1/payment-pages/update-page-status",
    CHECK_CUSTOM_LINK_EXIST:
      "payment-service/v1/payment-pages/custom-link-check-exist",
    GET_STATISTIC: "payment-service/v1/payment-pages/get-invoice-status",
    CREATE_INVOICES: "payment-service/v1/payment-pages/create-invoice",
    DELETE_INVOICES: "payment-service/v1/payment-pages/delete-invoice",
    MARK_AS_PAID: "payment-service/v1/payment-pages/update-invoice",
    CARD_STEP_1: "payment-service/v1/payment-pages/authentication-setups",
    CARD_STEP_3: "payment-service/v1/payment-pages/authentications",
    CARD_RETURN_URL: "payment-service/v1/payment-pages/card-handle-res",
    FETCH_CARD_DATA_RES: "payment-service/v1/payment-pages/card-payment-data",
    GET_SPLIT_TRANSACTION_FEES: "payment-service/v1/payment-pages/get-split-transaction-fees",
  },
  DISPUTEROUTE: {
    VERIFY_REFID: "transaction-service/v1/verify-tnx-ref-for-dispute",
    CREATE_DISPUTE: "dispute-service/v1/create-dispute",
    DISPUTE_LIST: "dispute-service/v1/list",
    ADMIN_DISPUTE_LIST: "dispute-service/v1/admin-list",
    DISPUTE_DETAILS: "dispute-service/v1/dispute-details",
    UPDATE_DISPUTE: "dispute-service/v1/update-dispute",
    ADMIN_DISPUTE_DETAILS: "dispute-service/v1/admin-dispute-details",
  },
  PLANS: {
    PLAN_PAGE: "plans",
    PLAN_LIST: "payment-service/v1/plans/get-plans",
    PLAN_DETAILS: "/plans/details",
    PLAN_CREATE: "payment-service/v1/plans/create-plan",
    PLAN_DETAILS_API: "payment-service/v1/plans/get-plan-details",
    PLAN_UPDATE: "payment-service/v1/plans/update-plan-details",
    PLAN_DELETE_API: "payment-service/v1/plans/delete-plan",
  },

  PRODUCTS: {
    PRODUCT_LIST: "payment-service/v1/products/get-products",
    CREATE_PRODUCT: "payment-service/v1/products/create-product",
    GET_PRODUCT_DETAILS: "payment-service/v1/products/get-product-details",
    GET_INVENTORY_DETAILS:
      "payment-service/v1/products/get-product-inventory-details",
    UPDATE_PRODUCT_DETAILS:
      "payment-service/v1/products/update-product-details",
    GET_DELIVERY_FEES: "payment-service/v1/products/get-delivery-fees",
    ADD_DELIVERY_FEES: "payment-service/v1/products/add-delivery-fees",
    UPDATE_DELIVERY_FEES: "payment-service/v1/products/update-delivery-fees",
    DELETE_DELIVERY_FEES: "payment-service/v1/products/delete-delivery-fees",
    GET_DIGITAL_FILES: "payment-service/v1/products/get-digital-download-files",
    GET_PREVIEW_PRODUCT_DETAILS: "payment-service/v1/products/preview",
    DOWNLOAD_PRODUCT_FETCH: "payment-service/v1/products/get-digital-products",
    UPLOAD_PRODUCT_MEDIA: "payment-service/v1/products/product-upload-media",
    GET_PRODUCT_MEDIA: "payment-service/v1/products/get-product-media",
    REMOVE_UPLOADED_MEDIA: "payment-service/v1/products/delete-product-media",
    DELETE_PRODUCT: "payment-service/v1/products/delete-product",
    ARCHIVE_PRODUCT: "payment-service/v1/products/archive-product",
    DUPLICATE_PRODUCT: "payment-service/v1/products/duplicate-product",
    ORDER_LIST: "payment-service/v1/products/get-product-orders",
    ORDER_LIST_CSV: "payment-service/v1/products/get-product-orders-csv",
    ORDER_DETAILS: "payment-service/v1/products/get-product-order-detail",
    DELIVER_ORDER: "payment-service/v1/products/deliver-order",
    ADD_PRODUCT_OPTION: "payment-service/v1/products/add-product-options",
    UPDATE_PRODUCT_OPTION:
      "payment-service/v1/products/update-product-option-details",
    DELETE_PRODUCT_OPTION: "payment-service/v1/products/delete-product-options",
    ADD_DEGITAL_FILE: "payment-service/v1/products/add-digital-download-files",
    DELETE_DIGITAL_FILES:
      "payment-service/v1/products/delete-digital-download-files",
    RENAME_DIGITAL_FILE:
      "payment-service/v1/products/rename-digital-download-files",
    UPDATE_VARIANT_DETAILS:
      "payment-service/v1/products/update-product-variant-details",
    BUY_PRODUCT: "payment-service/v1/products/buy-product",
    CHECK_SLUG_EXIST: "payment-service/v1/products/slugExist",
    UPDATE_EXPIRED_LINK: "payment-service/v1/products/set-download-link-expiry",
    DISCOUNT_CODES: "payment-service/v1/products/get-discount-codes",
    UPDATE_DISCOUT_CODE: "payment-service/v1/products/update-discount-code",
    CREATE_DESCOUNT_CODE: "payment-service/v1/products/add-discount-code",
    VERIFY_CODE: "payment-service/v1/products/verify-discount-code",
  },
  STORES: {
    CREATE_STORE: "payment-service/v1/stores/create-store",
    GET_STORES: "payment-service/v1/stores/get-stores",
    GET_STORE_DETAILS: "payment-service/v1/stores/get-store-details",
    UPDATE_STORE: "payment-service/v1/stores/update-store",
    DELETE_STORE: "payment-service/v1/stores/delete-store",
    DUPLICATE_STORE: "payment-service/v1/stores/duplicate-store",
    ADD_STORE_LISTING: "payment-service/v1/stores/add-store-listing",
    REMOVE_STORE_LISTING: "payment-service/v1/stores/remove-store-listing",
    GET_STORE_PRODUCTS: "payment-service/v1/stores/get-store-products",
    GET_STORE_ORDERS: "payment-service/v1/stores/get-store-orders",
    GET_STORE_ORDERS_CSV: "payment-service/v1/stores/get-store-orders-csv",
    GET_STORE_DELIVERY_FEES: "payment-service/v1/stores/get-store-delivery-fees",
    ADD_STORE_DELIVERY_FEE: "payment-service/v1/stores/add-store-delivery-fee",
    UPDATE_STORE_DELIVERY_FEE: "payment-service/v1/stores/update-store-delivery-fee",
    DELETE_STORE_DELIVERY_FEE: "payment-service/v1/stores/delete-store-delivery-fee",
    GET_STORE_DISCOUNT_CODES: "payment-service/v1/stores/get-store-discount-codes",
    CREATE_STORE_DISCOUNT_CODE: "payment-service/v1/stores/create-store-discount-code",
    UPDATE_STORE_DISCOUNT_CODE: "payment-service/v1/stores/update-store-discount-code",
    DELETE_STORE_DISCOUNT_CODE: "payment-service/v1/stores/delete-store-discount-code",
    GET_PUBLIC_STORE_DETAILS: "payment-service/v1/stores/get-public-store-details",
    GET_PUBLIC_STORE_PRODUCTS: "payment-service/v1/stores/get-public-store-products",
    GET_PUBLIC_STORE_DELIVERY_LOCATIONS: "payment-service/v1/stores/get-public-store-delivery-locations",
    STOREFRONT_CHECKOUT: "payment-service/v1/stores/storefront-checkout",
  },
  NOTIFICATION: "notification",

  DASHBOARDROUTE: {
    dashboard: "dashboard",
  },
  TRANSACTION: {
    DETAILS: "transaction/details",
  },
  DISPUTE: {
    LIST: "disputes",
    DETAILS: "disputes/detail",
  },
  REFUND: {
    DETAILS: "refund/details",
  },
  PAYMENT: {
    PAYMENT_PAGE: "pages",
    DETAILS: "pages/detail",
  },
  PROFILE_ROUTE: {
    PROFILE_INFO: "/info",
  },
  PRODUCT_ROUTE: {
    PRODUCTS: "product",
  },
  CUSTOMER_ROUTE: {
    CUSTOMER: "customer",
    CUSTOMER_DETAILS: "customer/details",
  },
  TRANSFER: {
    NEW_TRANSFER: "transfer/new",
    BULK_UPLOAD: "transfer/bulk-upload",
    BULK_UPLOAD_LIST: "transfer/bulk-upload/review",
  },

  SUBACCOUNT: {
    GET_LIST: "transaction-service/v1/subaccounts/all",
    GET_BANK_LIST: "transaction-service/v1/bank-list",
    CREATE_SUBACCOUNT: "transaction-service/v1/subaccounts",
    UPDATE_SUBACCOUNT: "transaction-service/v1/subaccounts/",
    GET_BY_ID: "transaction-service/v1/subaccounts/",
    BANK_VERIFY: "transaction-service/v1/verify-account",
    NEW_GET_LIST: "transaction-service/v1/subaccounts-new/all",
    NEW_CREATE_SUBACCOUNT: "transaction-service/v1/subaccounts-new",
    NEW_UPDATE_SUBACCOUNT: "transaction-service/v1/subaccounts-new/",
    NEW_GET_BY_ID: "transaction-service/v1/subaccounts-new/",
  },

  SPLIT_TRANSACTION: {
    GET_LIST: "transaction-service/v1/split-page/all",
    CREATE_SPLIT_PAGE: "transaction-service/v1/split-page",
    GET_BY_ID: "transaction-service/v1/split-page/",
    ADD_SUB_ACC: "transaction-service/v1/split-page/",
    DISABLE_SPLIT: "transaction-service/v1/split-page/",
  },

  SESSION_LOG: {
    ADD_SESSION: "transaction-service/v1/session-logs",
    GET_BY_TRANSACTION_ID: "transaction-service/v1/session-logs/transaction/",
  },

  PAYOUT: {
    GET_LIST: "transaction-service/v1/payout/all",
    GET_BY_ID: "transaction-service/v1/payout",
    GET_AMOUNT: "transaction-service/v1/payout/showPayoutAmount/",
    CREATE_REQUEST: "transaction-service/v1/payout/create-manual-payout",
  },

  UTILITY: {
    GET_BILLERS_GROUP: "transaction-service/v1/utility/biller-groups",
    GET_PROVIDERS_LIST:
      "transaction-service/v1/utility/biller-groups-providers",
    GET_PLAN_LIST: "transaction-service/v1/utility/package-by-biller",
    PROCESS_PAYMENT: "transaction-service/v1/utility/process-payment",
    HISTORY: "transaction-service/v1/utility/history",
  },

  PAGINATION: {
    limit: 10,
    total: 0,
    rotate: false,
    maxSize: 3,
  },
  NAVIGATION_ROUTE: {
    LOGIN: "auth/login",
    PROFILE: "profile",
    CHANGE_PASSWORD: "change-password",
    DASHBOARD: "dashboard",
    BALANCE: "balance",
  },
  DASHBOARD_API_ROUTE: {
    DASHBOARD_COUNT: "/dashboard/counts",
    DASHBOARD_TRANSACTION_DATA: "/dashboard/transactions",
    DASHBOARD_TRANSACTION_CATEGORY: "/dashboard/transactions-category",
    DASHBOARD_TRANSACTION_MONTH: "/dashboard/transactions-month",
  },
  SUBSCRIPTION: {
    GET_SUBSCRIPTION: "payment-service/v1/subscription/all",
    DETAIL_SUBSCRIPTION: "payment-service/v1/subscription/",
    SUBSCRIPTION_STATUS: "payment-service/v1/subscription/stats/amonunt",
  },
  SUBSCRIBER: {
    GET_SUBSCRIBER: "payment-service/v1/subscription/all-subscriber",
    SUBSCRIBER_STATUS:
      "payment-service/v1/subscription/subscriber/stats/amonunt",
  },
  DATE_FORMAT: {
    timeStampFormat: "YYYY-MM-DD HH:mm:ss",
    dateFormat: "YYYY-MM-DD",
  },
  STATUS: {
    APPROVED: "Approved",
    REJECTED: "Rejected",
    PENDING: "Pending",
  },
  DOCUMENT_TYPE: {
    ID_CARD: "ID Card",
    BANK_STATEMENT: "Bank Statement",
    CAC_CERTIFICATE: "CAC Certificate",
    CAC_FORM_A: "CAC Form A",
    IDENTIFICATION_OF_DIRECTOR: "Means of Identification for one director",
    UTILITY_BILL: "Utility Bill",
    INTERNATIONAL_PASSPORT: "International Passport",
    COOPERATE_AFFAIRS_COMMISION: "Cooperate Affairs Commission",
    VOTERS_CARD: "Voters Card",
    NATIONAL_IDENTITY_NUMBER: "National Identity Number",
    DRIVERS_LICENSE: "Drivers License",
    STATUS_REPORT: "Status Report",
    MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION:
      "Memorandum and Articles of Association",
    CERTIFICATE_OF_INCORPORATION: "Certificate of Incorporation",
    REGULATED_BUSINESS_LICENSE: "Regulated Business License/Certificate",
  },
  // Business Activity single-select for Nature of Business - distinct from
  // Industry (the general 12-value sector list). See wayfinder map
  // P-T-L/merchant-angular#170.
  BUSINESS_ACTIVITY: {
    ECOMMERCE: "Ecommerce",
    CRYPTOCURRENCY: "Cryptocurrency",
    DIGITAL_ASSETS: "Digital Assets",
    BETTING: "Betting",
    LENDING: "Lending",
    FOREX_BDC: "Forex/Bureau de Change",
    // Catch-all for a legitimate business whose activity doesn't fit any of
    // the categories above (found live via business 562, "Sambo Coporation")
    // - without this they had no valid option to select. Unregulated, same
    // as Ecommerce - not in REGULATED_BUSINESS_ACTIVITIES.
    OTHER: "Other",
  },
  // Business Activity values that require a license/certificate upload and
  // trigger Nature of Business Review before the merchant can go live.
  REGULATED_BUSINESS_ACTIVITIES: [
    "Cryptocurrency",
    "Digital Assets",
    "Betting",
    "Lending",
    "Forex/Bureau de Change",
  ],
  BUSINESS_CATEGORY: {
    INDIVIDUAL: "Individual",
    CORPORATE: "Corporate",
  },

  LIST_OF_ROLE: {
    CAN_VIEW_BUSINESS_PERFORMANCE_METRICS:
      "<strong>Can</strong> View Business Performance Metrics",
    CAN_VIEW_TRANSACTIONS: "<strong>Can</strong> View Transactions",
    CAN_EXPORT_TRANSACTIONS: "<strong>Can</strong> Export Transactions",
    CAN_MANAGE_REFUNDS_AND_DISPUTES:
      "<strong>Can</strong> Manage Refunds & Disputes",
    CAN_VIEW_CUSTOMERS: "<strong>Can</strong> View Customers",
    CAN_CREATE_NEW_CUSTOMERS: "<strong>Can</strong> Create New Customers",
    CAN_MANAGE_AND_UPDATE_CUSTOMERS:
      "<strong>Can</strong> Manage & Update Customers",
    // CAN_VIEW_CUSTOMER_INSIGHTS: "<strong>Can</strong> View Customer Insights",
    CAN_VIEW_PAYOUTS: "<strong>Can</strong> View Payouts",
    CAN_EXPORT_PAYOUTS: "<strong>Can</strong> Export Payouts",
    CAN_VIEW_TRANSFERS: "<strong>Can</strong> View Transfers",
    CAN_EXPORT_TRANSFERS: "<strong>Can</strong> Export Transfers",
    CAN_CREATE_AND_MANAGE_TRANSFERS:
      "<strong>Can</strong> Create and Manage Transfers",
    CAN_VIEW_BALANCE_HISTORY: "<strong>Can</strong> View Balance History",
    CAN_EXPORT_BALANCE_HISTORY: "<strong>Can</strong> Export Balance History",
    CAN_VIEW_PAYMENT_PAGES: "<strong>Can</strong> View Payment Pages",
    CAN_CREATE_AND_MANAGE_PAYMENT_PAGES:
      "<strong>Can</strong> Create and Manage Payment Pages",
    CAN_VIEW_PRODUCTS: "<strong>Can</strong> View Products",
    CAN_CREATE_AND_MANAGE_PRODUCTS:
      "<strong>Can</strong> Create and Manage Products",
    CAN_VIEW_INVOICES: "<strong>Can</strong> View Invoices",
    CAN_CREATE_AND_MANAGE_INVOICES:
      "<strong>Can</strong> Create and Manage Invoices",
    CAN_VIEW_SUBACCOUNTS_AND_SPLITS:
      "<strong>Can</strong> View Subaccounts & Splits",
    CAN_CREATE_AND_MANAGE_SUBACCOUNTS_AND_SPLITS:
      "<strong>Can</strong> Create and Manage Subaccounts & Splits",
    CAN_VIEW_PLANS_AND_SUBSCRIPTIONS:
      "<strong>Can</strong> View Plans & Subscriptions",
    CAN_CREATE_AND_MANAGE_PLANS_AND_SUBSCRIPTIONS:
      "<strong>Can</strong> Create and Manage Plans & Subscriptions",
    CAN_VIEW_BUSINESS_SETTINGS_AND_PREFERENCES:
      "<strong>Can</strong> View Business Settings & Preferences",
    CAN_EDIT_BUSINESS_SETTINGS_AND_PREFERENCES:
      "<strong>Can</strong> Edit Business Settings & Preferences",
    CAN_VIEW_API_KEYS_AND_WEBHOOKS:
      "<strong>Can</strong> View API Keys & Webhooks",
    CAN_MANAGE_API_KEYS_AND_WEBHOOKS:
      "<strong>Can</strong> Manage API Keys & Webhooks",
    CAN_VIEW_USERS: "<strong>Can</strong> View Users",
    CAN_MANAGE_AND_INVITE_USERS: "<strong>Can</strong> Manage and Invite Users",
    CAN_VIEW_BANK_ACCOUNTS_SETTINGS:
      "<strong>Can</strong> View Bank Accounts Settings",
    CAN_MANAGE_BANK_ACCOUNTS_SETTINGS:
      "<strong>Can</strong> Manage Bank Accounts Settings",
    CAN_MANAGE_TERMINALS: "<strong>Can</strong> Manage Terminals",
    CAN_MANAGE_UTILITY: "<strong>Can</strong> Manage Utility",
    CAN_VIEW_UTILITY: "<strong>Can</strong> View Utility",
  },
  ACTION_TYPE: {
    ARCHIVE: "archive",
    RESTORE: "restore",
  },
  PAGE_STATUS: {
    PUBLISHED: "Published",
    UNPUBLISHED: "Unpublished",
  },
  CARD_TYPE: {
    VISA: "visa",
    MASTER_CARD: "masterCard",
    DEFAULT: "default",
  },
  GRAPH_PERIOD: {
    TODAY: "Today",
    WEEK: "This Week",
    MONTH: "This Month",
    YEAR: "This Year",
    THIRTY_DAYS: "Last 30 Days",
    NINGHTY_DAYS: "Last 90 Days",
    CUSTOM: "Custom Period",
  },

  ModelResponsible: {
    AutoTopup: "Auto_Topup",
    BVNCharge: "BVN_Charge",
    BVNChargeR: "BVN_Charge_R",
    BVNResolve2Charge: "BVN_Resolve_2_Charge",
    BVNResolve2ChargeR: "BVN_Resolve_2_Charge_R",
    BVNMatchCharge: "BVN_Match_Charge",
    Transaction: "Transaction",
    Transfer: "Transfer",
    TransferR: "Transfer_R",
    TransferCharge: "Transfer_Charge",
    TransferChargeR: "Transfer_Charge_R",
    PayoutRequest: "Payout_Request",
    PayoutRequestCharge: "Payout_Request_Charge",
    Settlement: "Settlement",
    Refund: "Refund",
    RefundR: "Refund_R",
    External: "External",
    Topup: "Topup",
    Dedicated_Nuban: "Dedicated_Nuban",
    Fees: "Fees",
    Airtime: "Airtime",
  },
  DiscountType: {
    FIXED: "Fixed Amount",
    PERCENTAGE: "Percentage",
    FREE_DILIVARY: "Free Delivery",
  },
  SETTINGS_TABS: {
    PROFILE: "Profile",
    CONTACT: "Contact",
    COMPLIANCE: "Compliance",
    ACCOUNTS: "Accounts",
    PREFERENCES: "Preferences",
    TEAM: "Team",
    API_KEYS_WEBHOOKS: "API Keys & Webhooks",
  },
  DISPUTE_DUE_TIME: 16,
  DISPUTE_REFUND_TYPES: [
    {
      value: "full",
      lable: "Full refund",
    },
    {
      value: "partial",
      lable: "Partial refund",
    },
  ],

  ORDER_STATUS: {
    PAID: "Paid",
    PENDING: "Pending",
    DELIVERED: "Delivered",
    CANCELLED: "Cancelled",
    REFUNDED: "Refunded",
  },
  SUPPORTED_EXTENSIONS: {
    text: ['pdf', 'doc', 'docx', 'txt', 'odt', 'rtf', 'wpd'],
    audio: ['wav', 'mid', 'midi', 'mp3', 'ogg', 'aac', 'm4a', 'flac', 'alac', 'aiff'],
    video: ['avi', 'divx', 'flv', 'm4v', 'mkv', 'mov', 'mp4', 'mpeg', 'mpg', 'ogm', 'ogv', 'ogx', 'rm', 'rmvb', 'smil', 'webm', 'wmv', 'xvid', '3g2', '3gp', 'asx'],
    spreadsheet: ['csv', 'xlsx'],
    compressed: ['zip', 'pkg', 'rar'],
    images: ['ai', 'gif', 'psd', 'svg', 'tiff', 'indd', '3dm', 'jpeg', 'jpg', 'png'],
    presets: ['xmp', 'fxp'],
    slides: ['key', 'odp', 'ppt', 'pptx'],
    other: ['aep', 'html', 'xlsx', 'htm', 'obj', 'fbx', 'ply', 'stl', 'wlr']
  }
};
